export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '18c90fac-c68b-4431-81b6-9440b7f8e501';
export const MODAL_CLOSE_SEC = 2.5;
